/** 全局主题配置与切换（仅影响布局壳层） */
export const THEME_STORAGE_KEY = 'cms-theme';

export const THEMES = [
  {
    key: 'default',
    name: '经典青绿',
    desc: '品牌色 · 清爽自然',
    preview: ['linear-gradient(135deg, #0caf87 0%, #099a75 100%)', '#f0f2f5'],
    accent: '#0caf87',
    icon: 'el-icon-sunny',
  },
  {
    key: 'blue',
    name: '晴空蓝',
    desc: '明亮 · 商务专业',
    preview: ['linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)', '#eff6ff'],
    accent: '#2563eb',
    icon: 'el-icon-cloudy',
  },
  {
    key: 'ocean',
    name: '深海青',
    desc: '通透 · 冷静专注',
    preview: ['linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)', '#ecfeff'],
    accent: '#0891b2',
    icon: 'el-icon-coordinate',
  },
  {
    key: 'sunset',
    name: '暖阳橙',
    desc: '活力 · 温暖亲和',
    preview: ['linear-gradient(135deg, #fb923c 0%, #ea580c 100%)', '#fff7ed'],
    accent: '#ea580c',
    icon: 'el-icon-hot-water',
  },
  {
    key: 'purple',
    name: '紫罗兰',
    desc: '优雅 · 现代质感',
    preview: ['linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)', '#f5f3ff'],
    accent: '#7c3aed',
    icon: 'el-icon-magic-stick',
  },
  {
    key: 'rose',
    name: '玫瑰晨露',
    desc: '柔和 · 精致细腻',
    preview: ['linear-gradient(135deg, #f472b6 0%, #e11d48 100%)', '#fff1f2'],
    accent: '#e11d48',
    icon: 'el-icon-star-on',
  },
  {
    key: 'slate',
    name: '石墨灰',
    desc: '克制 · 极简高级',
    preview: ['linear-gradient(135deg, #64748b 0%, #475569 100%)', '#f1f5f9'],
    accent: '#475569',
    icon: 'el-icon-office-building',
  },
  {
    key: 'dark',
    name: '午夜深邃',
    desc: '暗色 · 护眼沉浸',
    preview: ['linear-gradient(135deg, #1e293b 0%, #0f172a 100%)', '#0f1117'],
    accent: '#34d399',
    icon: 'el-icon-moon',
  },
];

/** 兼容旧版 colors 字段 */
THEMES.forEach((item) => {
  if (!item.colors) {
    item.colors = item.preview;
  }
});

export function getThemeMeta(themeKey) {
  return THEMES.find((item) => item.key === themeKey) || THEMES[0];
}

export function getStoredTheme() {
  const saved = localStorage.getItem(THEME_STORAGE_KEY);
  if (saved && THEMES.some((item) => item.key === saved)) {
    return saved;
  }
  return 'default';
}

export function applyTheme(themeKey) {
  const theme = THEMES.some((item) => item.key === themeKey) ? themeKey : 'default';
  const meta = getThemeMeta(theme);
  document.documentElement.setAttribute('data-theme', theme);
  document.documentElement.style.setProperty('--theme-accent', meta.accent);
  localStorage.setItem(THEME_STORAGE_KEY, theme);
  return theme;
}

export function initTheme() {
  return applyTheme(getStoredTheme());
}



// WEBPACK FOOTER //
// ./src/utils/theme.js